var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "panelGroup", staticClass: "cf-node-properties__panel-group row" },
    [
      _c("GenericProps", {
        attrs: {
          "node-id": _vm.node.id,
          settings: _vm.settings,
          "audio-parameters": _vm.audioParameters,
          parameters: _vm.filteredNodeParameters
        },
        on: { "update:settings": _vm.onSettingsUpdate }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cf-node-properties__field col-md-12" },
        [
          _c("legend", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "MENU_ROUTES",
                expression: "'MENU_ROUTES'"
              }
            ],
            staticClass: "cf-node-properties__legend"
          }),
          _vm._v(" "),
          !_vm.settings.voiceResponse
            ? _c(
                "Draggable",
                {
                  model: {
                    value: _vm.routeList,
                    callback: function($$v) {
                      _vm.routeList = $$v
                    },
                    expression: "routeList"
                  }
                },
                _vm._l(_vm.routeList, function(route) {
                  return _c("RoutePanel", {
                    key: route.id,
                    attrs: {
                      index: route.index,
                      route: route,
                      "add-routes": true,
                      sortable: true
                    },
                    on: {
                      addNodeToRoute: function($event) {
                        return _vm.addNodeToRoute($event, route)
                      }
                    }
                  })
                }),
                1
              )
            : _c(
                "div",
                [
                  _vm._l(_vm.keywordRouteList, function(route, idx) {
                    return _c(
                      "RoutePanel",
                      {
                        key: "voice-route-" + route.routeIndex,
                        attrs: {
                          index: route.index,
                          route: route,
                          "add-routes": true,
                          sortable: false,
                          "open-options": true
                        },
                        on: {
                          addNodeToRoute: function($event) {
                            return _vm.addNodeToRoute($event, route)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "voice-route-content" },
                          [
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("ROUTE_KEYWORD")) +
                                  "\n            "
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top",
                                    value: _vm.$t("ROUTE_KEYWORD_TT"),
                                    expression: "$t('ROUTE_KEYWORD_TT')",
                                    modifiers: { top: true }
                                  }
                                ],
                                staticClass: "fa fa-question-circle m-l-5",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("InputText", {
                              attrs: {
                                placeholder: "e.g., Medicare",
                                error: _vm.getKeywordError(route),
                                required: true
                              },
                              on: { input: _vm.debouncedRouteInputChange },
                              model: {
                                value: route.keywordsInput,
                                callback: function($$v) {
                                  _vm.$set(route, "keywordsInput", $$v)
                                },
                                expression: "route.keywordsInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.keywordRouteList.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-danger m-t-10",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeKeywordRoute(idx)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-trash" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("REMOVE_ROUTE")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block m-t-10",
                      on: { click: _vm.addKeywordRoute }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" " + _vm._s(_vm.$t("ADD_ROUTE")) + "\n      ")
                    ]
                  )
                ],
                2
              )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showIvaConfirmation
        ? _c("IvaConfirmationModal", { on: { confirm: _vm.onIvaConfirm } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }